const AnswerRadio = ({ answer, question }) => {
  const answerDetails = answer?.answer?.other_details;

  return (
    <>
      {answerDetails?.radio_tag && (
        <div className=" d-flex align-items-center gap-10 mb-2">
          <div
            className="rounded-pill px-3 py-1  fw-sbold themeBlue"
            style={{ background: "#BEF9FF" }}
          >
            {answerDetails?.radio_tag}
          </div>
        </div>
      )}
      <p className="m-0 themeBlue">
        {answer?.answer?.answer}
      </p>
    </>
  )
}

export default AnswerRadio;